import { ComponentPropsWithoutRef } from 'react';

export function Th(props: ComponentPropsWithoutRef<'th'>) {
  return (
    <th
      {...props}
      className="typography-body-m text-grayscale600 px-24 py-16"
    />
  );
}
